import Logo from '../../src/Gif/1739196168277Fusion Logo.png'
export const GOOGLE_API_KEY = "AIzaSyB0VFLrPEaYGqP4FVdGDEeUUN6Ks9AZPao"; 
export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoic2lnbndpc2UiLCJhIjoiY21jOWIzbHZqMDB4YjJrc2xma2poaWthaSJ9.IBp9oEABcju66Oj2awW0QA';
export const defaultZipCode = '85122'; 
export const ChatGifApiKey = 'AIzaSyBFaHxqfZL4xpwtA5WnSqXmrUvCvJ2bFzc'
export const SEND_EMAIL = false

// export const GOOGLE_API_KEY = "AIzaSyBe6vrykAsiKjwIHWOUcfH1Li4VT-2LHTg";

// export const REST_API_END_POINT = "http://localhost:4000/webservice/";
// export const REST_API = "http://localhost:4000/";
// export const REST_API_IO = "http://localhost:4000";
// export const BASE_URL = "http://localhost:4000/"
// export const DOMAIN = 'localhost'


// arizona
// export const VERSION = '5.25';

//DEV
// export const VERSION = '7.12';

//RiverSide
export const VERSION = '1.00';

// arizona.signwisesolutions.com
export const BASE_URL = "https://support.joymarketplace.io/"
export const REST_API_END_POINT = "https://support.joymarketplace.io/backend/webservice/";
export const REST_API = "https://support.joymarketplace.io/backend/";
export const REST_API_IO = "https://socket.signwisesolutions.com";
export const DOMAIN = 'support';

// dev.signwisesolutions.com
// export const BASE_URL = "https://dev.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://dev-api.signwisesolutions.com/webservice/";
// export const REST_API = "https://dev-api.signwisesolutions.com/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const DOMAIN = 'dev';

// oklahoma.signwisesolutions.com/
// export const BASE_URL = "https://oklahoma.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://oklahoma.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://oklahoma.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const DOMAIN = 'oklahoma';

// riverside.signwisesolutions.com/
// export const BASE_URL = "https://riv.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://riv.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://riv.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const DOMAIN = 'riv';

//la.signwisesolutions.com/
// export const BASE_URL = "https://la.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://la.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://la.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const DOMAIN = 'la';

// //manteca.signwisesolutions.com/
// export const BASE_URL = "https://manteca.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://manteca.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://manteca.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const DOMAIN = 'manteca';

//denver.signwisesolutions.com/
// export const BASE_URL = "https://denver.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://denver.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://denver.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const DOMAIN = 'denver';

//cosprings.signwisesolutions.com/
// export const BASE_URL = "https://cosprings.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://cosprings.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://cosprings.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const DOMAIN = 'cosprings';

//lasvegas.signwisesolutions.com/
// export const BASE_URL = "https://lasvegas.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://lasvegas.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://lasvegas.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const DOMAIN = 'lasvegas';

// wiseai.signwisesolutions.com
// export const BASE_URL = "https://wiseai.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://wiseai.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://wiseai.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const DOMAIN = 'wiseai';

// my.signwisesolutions.com
// export const REST_API_END_POINT = "https://api.signwisesolutions.skyniche.website/webservice/";
// export const REST_API = "https://api.signwisesolutions.skyniche.website/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const BASE_URL = "https://my.signwisesolutions.com/";
// export const DOMAIN = 'my';


const user =  JSON.parse(localStorage.getItem('user'))

export const COMPANY_LOGO = user?.company_logo || Logo
export const COMPANY_NAME = user?.company_name || 'Joy Marketplace Support'

export const PUBNUB_PUBLISH_KEY= 'pub-c-014b4ee8-2c24-46d0-ae01-4a933c3fee2e'
export const PUBNUB_SUBSCRIBE_KEY= 'sub-c-53f81de7-6961-4d0e-87bb-f3defdef49a0'
export const PUBNUB_SECRET_KEY="sec-c-NTY0NDYwZDEtN2M3MC00Y2YwLWE4ZmItMzdmMjc5MTY1YTNl"

// export const UNITS = [
//     { id: 1, name: 'Square feet', short_name: 'Sq ft', unit_id: 1 },
//     { id: 2, name: 'Linear feet', short_name: 'Lin ft', unit_id: 1 },
//     { id: 3, name: 'Square inches', short_name: 'Sq in', unit_id: 1 },
//     { id: 4, name: 'Unit', short_name: 'Unit', unit_id: 2 },
//     { id: 5, name: 'Gallons', short_name: 'Gal', unit_id: 3 },
//     { id: 6, name: 'Quarts', short_name: 'Qt', unit_id: 3 },
//     { id: 7, name: 'Milliliter', short_name: 'ml', unit_id: 3 },
//     { id: 8, name: 'Ounce', short_name: 'oz', unit_id: 3 },
//     { id: 9, name: 'Kilogram', short_name: 'kg', unit_id: 4 },
//     { id: 10, name: 'Gram', short_name: 'g', unit_id: 4 },
//     { id: 11, name: 'Milligram', short_name: 'mg', unit_id: 4 },
// ];

export const UNITS = [
  { id: 1, name: 'Square feet', short_name: 'Sq ft', unit_id: 1 },
  { id: 2, name: 'Linear feet', short_name: 'Lin ft', unit_id: 1 },
  { id: 3, name: 'Square inches', short_name: 'Sq in', unit_id: 1 },
  { id: 16, name: 'Yards', short_name: 'yd', unit_id: 1 },
  { id: 4, name: 'Unit', short_name: 'Unit', unit_id: 2 },
  { id: 5, name: 'Gallons', short_name: 'Gal', unit_id: 3 },
  { id: 6, name: 'Quarts', short_name: 'Qt', unit_id: 3 },
  { id: 7, name: 'Milliliter', short_name: 'ml', unit_id: 3 },
  { id: 8, name: 'Liter', short_name: 'L', unit_id: 3 },
  { id: 9, name: 'Pint', short_name: 'pt', unit_id: 3 },
  { id: 10, name: 'Half Pint', short_name: 'half-pt', unit_id: 3 },
  { id: 11, name: 'Ounce', short_name: 'oz', unit_id: 3 },
  { id: 12, name: 'Kilogram', short_name: 'kg', unit_id: 4 },
  { id: 13, name: 'Gram', short_name: 'g', unit_id: 4 },
  { id: 14, name: 'Milligram', short_name: 'mg', unit_id: 4 },
  { id: 15, name: 'Each', short_name: 'EA', unit_id: 2 },
];

export const MATERIALTYPES = [
    { id: 1, name: 'Inventory', },
    { id: 2, name: 'Non-Inventory', },
    { id: 3, name: 'Services', },
    // { id: 4, name: 'Buldle', },
]

//For messenger chat
export const STATUS_OPTIONS = [
  { id: 1, statusData: 'online', label: 'Available' },
  { id: 2, statusData: 'away', label: 'Away' },
  { id: 3, statusData: 'busy', label: 'Busy' },
  { id: 4, statusData: 'invisible', label: 'Invisible' },
  { id: 5, statusData: 'dnd', label: 'Do not disturb' },
];





export const currentFacilityId = 1
export const FacilityTypes = [ // make true for current facility
  { id: 1, label: 'Arizona', code: 'AZ',default:true,color:"primary" },
  { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
  { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
  // { id: 4, label: 'Dev', code: 'DEV',default:false,color:"success" },
]

export const filteredOtherFacilityTypes = FacilityTypes.filter(facility => facility.id !== currentFacilityId)

// export const currentFacilityName = 'Arizona'
// export const currentFacilityName = 'Riverside'
// export const currentFacilityName = 'LA'